import { render } from "./admin_dash.vue?vue&type=template&id=51524ca0"
import script from "./admin_dash.vue?vue&type=script&lang=js"
export * from "./admin_dash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__